import React, { useState } from 'react';
import { useLocale } from '../context/LocaleContext';
import InvestorMetrics from '../components/InvestorMetrics';
import FileProcessing from '../components/FileProcessing';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { BarChart3, FileText, Users, Settings, Shield } from 'lucide-react';

const AdminDashboard = () => {
  const { t } = useLocale();
  const [activeTab, setActiveTab] = useState('metrics');

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      {/* Header */}
      <header className="bg-white dark:bg-gray-800 shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 py-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-2xl font-bold text-gray-900 dark:text-white flex items-center gap-2">
                <Shield className="h-6 w-6 text-purple-500" />
                Admin Dashboard
              </h1>
              <p className="text-sm text-gray-500">System metrics, user management, and tools</p>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 py-6 sm:px-6 lg:px-8">
        <Tabs value={activeTab} onValueChange={setActiveTab}>
          <TabsList className="mb-6">
            <TabsTrigger value="metrics" className="flex items-center gap-2">
              <BarChart3 className="h-4 w-4" /> Investor Metrics
            </TabsTrigger>
            <TabsTrigger value="files" className="flex items-center gap-2">
              <FileText className="h-4 w-4" /> File Processing
            </TabsTrigger>
            <TabsTrigger value="users" className="flex items-center gap-2">
              <Users className="h-4 w-4" /> Users
            </TabsTrigger>
          </TabsList>

          <TabsContent value="metrics">
            <InvestorMetrics />
          </TabsContent>

          <TabsContent value="files">
            <FileProcessing />
          </TabsContent>

          <TabsContent value="users">
            <div className="bg-white dark:bg-gray-800 rounded-lg p-8 text-center">
              <Users className="h-12 w-12 text-gray-400 mx-auto mb-4" />
              <h3 className="text-lg font-medium">User Management</h3>
              <p className="text-gray-500">View and manage platform users</p>
              {/* User list component would go here */}
            </div>
          </TabsContent>
        </Tabs>
      </main>
    </div>
  );
};

export default AdminDashboard;
